<template>
  <BaseForm
    class="informations-form"
    :action="action"
    :response-to="responseTo"
    gtm-submit-event="form_submit_informations"
  >
    <template #fields>
      <NameField hide-details solo flat />
      <EmailField hide-details solo flat />
      <MessageField hide-details rows="3" solo flat />
      <PolicyPrivacyField class="mb-4" hide-details solo flat dark />
    </template>

    <template #button>
      <ButtonWidget color="secondary" text-color="white" block>
        <span class="text-body-1 font-weight-medium"> Enviar </span>
      </ButtonWidget>
    </template>
  </BaseForm>
</template>

<script>
import BaseForm from "./BaseForm.vue";
import NameField from "./fields/NameField.vue";
import EmailField from "./fields/EmailField.vue";
import MessageField from "./fields/MessageField.vue";
import PolicyPrivacyField from "./fields/PolicyPrivacyField.vue";
import ButtonWidget from "../widgets/ButtonWidget.vue";

export default {
  props: {
    action: {
      type: String,
      required: true,
    },
    responseTo: String,
    responseText: String,
  },
  components: {
    BaseForm,
    NameField,
    EmailField,
    MessageField,
    PolicyPrivacyField,
    ButtonWidget,
  },
};
</script>

<style lang="scss">
.informations-form {
  .base-form-fields {
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
  }
}
</style>
